module.exports = __webpack_public_path__ + "static/media/cp17.c1300efc.pdf";